/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";

export const DateFieldViewer = props => {
	const {Value: value, FieldDef: fieldDef = {}} = props;
	const {customData = {}} = fieldDef;
	const {
		format = 'MMMM d, yyyy',
		nullDisplayValue = "",
	} = customData;
	return value ? DateUtils.FormatDate(value, format) : nullDisplayValue;
}
